import React from 'react';
import { compose } from 'redux';
import { reduxForm, SubmissionError } from 'redux-form';
import _isEmpty from 'lodash/isEmpty';
import { reduxFormPropTypes } from 'constants/propTypes';

export const asFormSubmit = (onSubmit, submitValidator, props) => values => {
  let deferred = {};
  const promise = new Promise((resolve, reject) => {
    deferred = {
      resolveSubmit: resolve,
      rejectSubmit: (errorMessage, validationErrors) => {
        if (!errorMessage && !validationErrors) {
          return resolve();
        }

        const errorObj = errorMessage ? { _error: errorMessage } : validationErrors;
        return reject(new SubmissionError(errorObj));
      },
    };
  });

  if (submitValidator) {
    const errors = submitValidator(values, props);

    if (!_isEmpty(errors)) {
      deferred.rejectSubmit(null, errors);
      return promise;
    }
  }

  onSubmit(values, deferred);

  return promise;
};

const withForm =
  (ownProps = {}) =>
  WrappedComponent => {
    const withFormHOC = props => {
      const { onSubmit, name: nameFromProps, ...restProps } = props;
      const { name = nameFromProps, syncValidator = () => ({}), submitValidator, ...restOwnProps } = ownProps;

      const mergedProps = { ...restProps, ...restOwnProps };

      return (
        <WrappedComponent
          {...mergedProps}
          name={name} // so the form name is available in reduxForm event handlers on `props.name`
          form={name}
          validate={syncValidator}
          onSubmit={asFormSubmit(onSubmit, submitValidator, mergedProps)}
        />
      );
    };

    withFormHOC.propTypes = reduxFormPropTypes.form;

    return withFormHOC;
  };

export default config => compose(withForm(config), reduxForm());
